import { Container } from '@/components/ui/container';
import { motion } from 'framer-motion';
import { process } from '@/lib/process';
import { ProcessModal } from '@/components/process-modal';
import Image from 'next/image';

export default function LandingProcess() {
	return (
		<Container className="max-w-5xl">
			<motion.div
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8 }}
				className="text-center mb-16"
			>
				<h2 className="text-4xl md:text-5xl font-bold mb-6">How We Work Together</h2>
				<p className="text-xl text-muted-foreground">
					Whether you&apos;re looking for hands-on builds, strategic guidance, or a long-term
					partner — here&apos;s how we make it simple, flexible, and tailored to your business.
				</p>
			</motion.div>

			<motion.div
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8, delay: 0.2 }}
				className="relative aspect-[21/9] max-w-4xl mx-auto mb-16 rounded-xl overflow-hidden"
			>
				<Image
					src="/images/process/collaboration.png"
					alt="Our collaborative process visualization"
					fill
					className="object-cover"
					sizes="(max-width: 768px) 90vw, (max-width: 1200px) 80vw, 1000px"
					priority
				/>
			</motion.div>

			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
				{process.map((step, index) => (
					<ProcessModal
						key={step.title}
						title={step.title}
						description={step.description}
						icon={step.icon}
						index={index}
						totalSteps={process.length}
						details={step.modalDetails}
					/>
				))}
			</div>
		</Container>
	);
}
